import { useJobDataStore } from '../stores/job-store';

export default async function fetchSuccessPageData() {
    const jobData = useJobDataStore();

    if (jobData.jobId !== 0) {
        if (!jobData.relatedJobsFetched) jobData.fetchRelatedJobs(jobData.jobId);
        if (!jobData.recentJobsFetched) jobData.fetchRecentJobs();
    }
}
